import React, {PureComponent} from "react";
import IconTitle from "../../components/iconTitle";
import {faEye, faHistory, faSmileWink, faSpinner} from "@fortawesome/pro-solid-svg-icons";
import {Get, OpenFile} from "../../components/request";
import DivTable from "../../components/divTable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class ParcoursAnterieur extends PureComponent {
    state = {
        loading: false,
        list: []
    }

    async componentDidMount() {
        await this.search();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search && this.props.search !== 0) {
            await this.search();
        }
    }

    async search() {
        this.setState({
            loading: true,
            list: [],
            date: ""
        });

        const {body} = await Get(`/v1/extranet/verifications/${this.props.search}/ParcoursAnterieur`);

        setTimeout(() => this.setState({
            loading: false,
            list: body,
        }), 250);
    }

    render() {
        return (
            <section>
                <IconTitle icon={faHistory} type={"h3"} content={"Parcours antérieur"}/>
                {this.state.list.length > 0 ?
                    <DivTable columns={{
                        'Libelle': 'ParcoursAnterieurLibelle'
                    }}
                              array={this.state.list}
                              actions={[{
                                  onClick: id => this.download(id),
                                  icon: faEye, title: "Visualiser"
                              }]}/>
                    :
                    <div style={{marginLeft: "4.5rem"}}>
                        {this.state.loading
                            ? <FontAwesomeIcon icon={faSpinner} className={"fa-3x"} pulse={true}/>
                            : <IconTitle type={"h6"} classContent={"ml-1 pl-1"}
                                         icon={faSmileWink} content={"Parcours antérieur vide"}/>}
                    </div>}
            </section>
        );
    }

    async download(id) {
        let newWindow = await OpenFile(`/v1/extranet/verifications/${this.props.search}/ParcoursAnterieur/${id}`);
        newWindow.document.title = this.props.matricule + " - " + this.state.list.find(f => f[f.IDPropertyName] === id).ParcoursAnterieurLibelle;
    }
}

export default ParcoursAnterieur;